import Events from '../../lib/events';
import { getScript, log } from '../../lib/util';

export default class ParselyTracker {
  constructor(player) {
    if (!player.allowPersonalizedCookies()) {
      return;
    }

    const siteId = player && player.asset && player.asset.parsely_site_id;
    this.player = player;
    if (!siteId) {
      throw new Error('siteId is required');
    }

    this.initConfig();
    this.isReady = false;

    this.ready = this.loadScript(siteId).then(() => {
      this.isReady = true;
      this.parsely = window.PARSELY;
    });
  }

  initConfig() {
    // https://www.parse.ly/help/integration/video_v2/#tracking-videos-that-play-in-iframes
    window.PARSELY = window.PARSELY || {
      autotrack: false,
      config: {
        heartbeat_should_honor_autotrack: true
      },
      video: {
        onPlay: (playerApi, videoId, metadata) => {
          log('Parsely onPlay', videoId, metadata);

          this.player.host.ping(host => {
            window.PARSELY.video.trackPlay(videoId, metadata, host.url);
          });
        }
      }
    };
  }

  loadScript(siteId) {
    return new Promise((resolve, reject) => {
      getScript(
        `//cdn.parsely.com/keys/${ siteId }/p.js`,
        resolve,
        reject
      );
    });
  }

  getMetadata() {
    const video = this.player.video;
    const videoJsPlayer = this.player.player;

    return {
      duration: Math.round(1000 * videoJsPlayer.duration()),
      image_url: videoJsPlayer.poster_,
      title: video.title_short || videoJsPlayer.currentSrc(),
      video_platform: 'chorus',
      link: video.id,
    };
  }

  track({ action }) {
    const self = this;
    if (!self.isReady) {
      log('Parsely: Attempted to track before ready');
      return;
    }

    const video = self.player.video;
    const videoJsPlayer = this.player.player;

    switch(action) {
    case Events.PLAY: {
      const metadata = self.getMetadata();
      log('Parsely track: PLAY', video.id, metadata);
      self.player.host.ping(host => {
        this.parsely.video.trackPlay(video.id, metadata, host.url);
      });
      break;
    }

    case Events.PAUSE: {
      const metadata = self.getMetadata();
      log('Parsely track: PAUSE', video.id, metadata);
      self.player.host.ping(host => {
        this.parsely.video.trackPause(video.id, metadata, host.url);
      });
      break;
    }

    case Events.COMPLETE:
      log('Parsely track: COMPLETE');
      this.parsely.video.reset(videoJsPlayer.currentSrc());
      break;

    default:
      log('Parsely: ', 'Ignoring event ' + action);
    }
  }
}
